import React from "react";
import { Box, Button, makeStyles, Tooltip, Typography, useMediaQuery, useTheme } from "@material-ui/core";

import Car from "./assets/car.svg";
import HelperIcon from "components/repairFunnel/assets/helperIcon.svg";
import ValidateIcon from "./assets/check.svg";

export default function ProductDelivery() {
  const classes = useStyle();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box display="flex" alignItems="center" pl={1} py={2}>
      <Box className={classes.delivery}>
        <Car />
        <Box ml={2}>
          <Typography variant="body2">
            <b>
              Livraison en 1 à 10 jours ouvrés
              {/* Material-UI Tooltip does not seem to work on mobile, so we hide it for now */}
              {!isTablet && (
                <Tooltip
                  arrow
                  placement={isTablet ? "bottom" : "right"}
                  classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow,
                  }}
                  title={
                    <>
                      <div className={classes.bulletContainer}>
                        <ValidateIcon width="16" height="16" className={classes.bullet} />
                        <Typography variant="caption" color="secondary">
                          <b>En vente locale</b>
                          <br />
                          24 à 72h
                        </Typography>
                      </div>
                      <div className={classes.bulletContainer}>
                        <ValidateIcon className={classes.bullet} />
                        <Typography variant="caption" color="secondary">
                          <b>Depuis le stock national</b>
                          <br />3 à 10 jours
                        </Typography>
                      </div>
                    </>
                  }
                >
                  <Button disableRipple className={classes.helper}>
                    <HelperIcon />
                  </Button>
                </Tooltip>
              )}
            </b>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  delivery: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: 16,
    textAlign: "left",
    padding: 0,
  },
  helper: {
    minWidth: "auto",
    height: "auto",
    padding: 0,
    marginLeft: theme.spacing(1),
  },
  tooltip: {
    padding: theme.spacing(2),
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    filter: "drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.1))",
    borderRadius: 12,
  },
  arrow: {
    color: theme.palette.common.white,
  },
  bulletContainer: {
    display: "grid",
    alignItems: "start",
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    gridTemplateColumns: "min-content 1fr",
  },
  bullet: {
    marginRight: theme.spacing(1),
    marginTop: 2,
  },
}));
